// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"120":"256231e07eeaa7be","329":"2976312a0e7c102d","334":"669a261380374549","418":"343539b65b9b3b9b","602":"ffe774828aed19ad","608":"6445a3c75b18f3c9","655":"a0caa9b24a3fff71"}[chunkId] + ".js";
};